<div class="content-wrapper" @fadeIn>

  @if ((addSongToPlaylistView$ | async) == ADD_SONG_TO_PLAYLIST_VIEW.ADD_SONG_TO_PLAYLIST_VIEW_MAIN) {
    <tun-select-playlist-view
    [@carousel]="{
      value: animationDirection,
      params: {
        duration: CAROUSEL_DURATION
      }
    }"
    class="fullContainer"
    [showQueueButton]="showAddToQueue"
    showAddPlaylistButton="true"
    (closeWithPlaylist)="onAddToPlaylist($event)"
    (selectQueue)="onSelectQueue()"
    (createPlaylist)="onCreatePlaylist()"
    >
  </tun-select-playlist-view>
}

@if ((addSongToPlaylistView$ | async) == ADD_SONG_TO_PLAYLIST_VIEW.ADD_SONG_TO_PLAYLIST_VIEW_CREATE) {
  <tun-create-new-playlist-to-add
    [@carousel]="{
      value: animationDirection,
      params: {
        duration: CAROUSEL_DURATION
      }
    }"
  class="fullContainer"
  (@carousel.start)="textViewAnimationStart($event)"
  (@carousel.done)="textViewAnimationDone($event)"
  [canReceiveFocus]="!textViewIsAnimating"
  (back)="onBackFromCreate()"
  (createPlaylist)="onCreateNewPlaylistWithName($event)"
  >
</tun-create-new-playlist-to-add>
}

</div>
